import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Pensé que tenía que cambiar a mis padres… pero entendí que el cambio empezaba por mí.',
  name: 'María L.',
  role: 'Argentina'
}, {
  quote: 'Dejé de reaccionar igual… ahora tengo más paz, incluso cuando las cosas no cambian.',
  name: 'Carolina R.',
  role: 'Argentina'
}, {
  quote: 'Lo que más me ayudó fue entender lo que me pasaba y poder soltarlo.',
  name: 'Lucía G.',
  role: 'Argentina'
}];
export function Testimonials() {
  return <section className="py-5 px-5 bg-[#000000]" data-id="element-270">
      <div className="max-w-xl mx-auto" data-id="element-271">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-white mb-8" data-id="element-272">
          💬 ¿Qué dicen quienes ya usan el Megapack?
        </h2>

        <div className="space-y-4" data-id="element-273">
          {testimonials.map((t, i) => <div key={i} className="bg-slate-900 border border-slate-800 p-5 rounded-xl" data-id="element-274">
              <div className="flex gap-0.5 mb-3" data-id="element-275">
                {[...Array(5)].map((_, j) => <Star key={j} size={14} className="fill-brand-yellow text-brand-yellow" data-id="element-276" />)}
              </div>
              <p className="text-slate-300 italic text-sm mb-3 leading-relaxed" data-id="element-277">
                "{t.quote}"
              </p>
              <div data-id="element-278">
                <p className="font-bold text-white text-sm" data-id="element-279">{t.name}</p>
                <p className="text-xs text-slate-500" data-id="element-280">{t.role}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}